import { Dialog } from '@mui/material'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '.MuiPaper-root': {
    borderRadius: '10px',
    padding: '24px',
    paddingTop: '60px'
  },
  [theme.breakpoints.down('md')]: {
    '> .MuiDialog-container > .MuiPaper-root': {
      margin: '0px',
      width: '90%'
    }
  }
}))

export const Section = styled(Box)(() => ({
  padding: '100px 86px',
  position: 'relative',

  '.MuiFormHelperText-root': {
    textAlign: 'center'
  }
}))

export const StyledIcon = styled('img')(() => ({
  position: 'absolute',
  top: '24px',
  right: '24px',
  cursor: 'pointer',
  padding: '10px'
}))

export const ClosureItemWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  flexDirection: 'row',
  padding: '20px 0px 10px 0px',

  input: {
    border: '1px solid #ddd'
  },

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}))

export const FormWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',

  '.create-edit-button': {
    background: '#047E50'
  },
  button: {
    height: '50px'
  },
  h4: {
    marginBottom: '8px'
  }
}))

export const ButtonsWrapper = styled(Box)(() => ({
  display: 'flex',
  marginBottom: '20px',
  gap: '12px',

  button: {
    width: 'max-content'
  }
}))

export const RowWrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: '1fr 1fr',
  marginBottom: '20px',

  '&.second-row': {
    marginBottom: '32px'
  },

  '.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl': {
    width: '100%'
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr'
  }
}))

export const Desc = styled('pre')(() => ({
  fontFamily: 'Inter',
  fontWeight: '400',
  fontSize: '15px',
  lineHeight: '140%',
  letterSpacing: '-1%',
  textAlign: 'center'
}))
